<script lang="ts">
  // Persistent Model Notice (PRD 5.1 wording, verbatim). Low-emphasis, always
  // visible, never an alert or interruption, never covers the simulation. Satisfies
  // both clauses of AC-4: analytic two-body Keplerian orbits, and that orbiting
  // bodies do not gravitationally interact.
  const NOTICE =
    "Kepler mode uses analytic two-body orbits. It demonstrates Kepler's laws " +
    'and does not calculate gravitational interactions between orbiting bodies.';

  // Story 2.2 (AC 8): an ADDITIONAL, calm, non-alarmist experimental-mode statement
  // shown ONLY when an alternate centre is active (centralBody !== 'sun'). The
  // persistent notice above stays unchanged and visible; this is additive, never a
  // modal or alert. The centre name and the boolean are read via `state` selectors
  // in Workspace and passed in as props (AD-2 layer table: no `core` import here).
  let {
    isAlternateCentre = false,
    centreName = ''
  }: { isAlternateCentre?: boolean; centreName?: string } = $props();
</script>

{#if isAlternateCentre}
  <div class="experimental-badge glass-panel" data-testid="experimental-badge" role="note">
    Experimental view: {centreName} is at the centre. This is not a realistic Solar System.
  </div>
{/if}

<div class="model-notice glass-panel data-mono" data-testid="model-notice">
  {NOTICE}
</div>

<style>
  .experimental-badge {
    position: absolute;
    /* Sit just above the persistent model notice (which sits above the HUD), so
       both stay visible without covering the simulation. */
    bottom: calc(var(--playback-hud-height) + 58px);
    left: 50%;
    transform: translateX(-50%);
    max-width: min(720px, calc(100vw - 2 * var(--edge-margin)));
    padding: 8px 18px;
    border-radius: var(--radius-full);
    /* Experimental-mode badge role: the secondary-container accent, never a planet
       identity colour and never `error` (reserved for collision/absorption). */
    background: var(--secondary-container, rgba(120, 144, 200, 0.28));
    color: var(--on-secondary-container, var(--on-surface));
    text-align: center;
    font-size: 13px;
    pointer-events: none;
    z-index: 6;
  }

  .model-notice {
    position: absolute;
    /* Sit just above the Playback HUD (bottom-centre) so the notice stays visible
       at all times and never overlaps the transport bar (Story 1.5 repositions it;
       the Story 1.1 wording is unchanged). The HUD height is the shared
       --playback-hud-height token so the offset tracks the bar automatically. */
    bottom: calc(var(--playback-hud-height) + 16px);
    left: 50%;
    transform: translateX(-50%);
    max-width: min(720px, calc(100vw - 2 * var(--edge-margin)));
    padding: 10px 18px;
    border-radius: var(--radius-full);
    color: var(--tertiary);
    opacity: 0.85;
    text-align: center;
    pointer-events: none;
    z-index: 5;
  }
</style>
